import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getMarketsService,
  getMarketDetailService,
  getOrderbookService,
  placeBetService,
  cancelBetService,
  getUserBetsService,
} from 'network/services/predictionMarket.service'

export const getMarkets = createAsyncThunk(
  'predictionMarket/getMarkets',
  async (params, thunkApi) => {
    try {
      const res = await getMarketsService(params)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error?.[0]?.description || 'Failed to load markets')
    }
  }
)

export const getMarketDetail = createAsyncThunk(
  'predictionMarket/getMarketDetail',
  async (payload, thunkApi) => {
    try {
      const conditionId = typeof payload === 'string' ? payload : payload.conditionId
      const interval = typeof payload === 'string' ? '1d' : (payload.interval || '1d')
      const res = await getMarketDetailService(conditionId, interval)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error?.[0]?.description || 'Failed to load market')
    }
  }
)

export const getOrderbook = createAsyncThunk(
  'predictionMarket/getOrderbook',
  async (params, thunkApi) => {
    try {
      const res = await getOrderbookService(params)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error?.[0]?.description || 'Failed to load orderbook')
    }
  }
)

export const placeBet = createAsyncThunk(
  'predictionMarket/placeBet',
  async (data, thunkApi) => {
    try {
      const res = await placeBetService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error?.[0]?.description || 'Failed to place bet')
    }
  }
)

export const cancelBet = createAsyncThunk(
  'predictionMarket/cancelBet',
  async (betId, thunkApi) => {
    try {
      const res = await cancelBetService(betId)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error?.[0]?.description || 'Failed to cancel bet')
    }
  }
)

export const getUserBets = createAsyncThunk(
  'predictionMarket/getUserBets',
  async (params, thunkApi) => {
    try {
      const res = await getUserBetsService(params)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error?.[0]?.description || 'Failed to load bets')
    }
  }
)
